import React, { useRef } from "react";
import Icon from "../icons/fontawsomeIcons";
const FileInput = ({
  containerStyle,
  inputStyle,
  onChange,
  onClick,
  RTL,
  disable,
  size,
  backgroundSize,
  fileName,
  message,
  name,
  iconName,
  iconPrefix,
  backgroundColor,
  uploaded,
  uploadedMessage,
  error,
  src,
  iconColor,
  styles,
  accept,
  source,
}) => {
  const inpurRef = useRef(null);
  const path = src ? URL.createObjectURL(src) : source ? source : "";

  return (
    <div className={`  ${containerStyle} `} dir={RTL ?? "rtl"}>
      <div className="align-items-center d-flex">
        <label
          className={`${inputStyle} file_icon_style align-items-center d-flex justify-content-center`}
          style={{
            width: backgroundSize ?? 40,
            height: backgroundSize ?? 40,
            cursor: "pointer",
            backgroundColor: disable
              ? "#60606085"
              : src
              ? "transparent"
              : "rgb(12, 87, 76)",
            ...styles,
          }}
        >
          {uploaded || source ? (
            <img
              alt={fileName}
              src={path}
              style={{
                width: backgroundSize,
                height: backgroundSize,
                borderRadius: "50%",
              }}
            />
          ) : (
            <Icon
              size={size ?? 22}
              name={iconName}
              iconPrefix={iconPrefix}
              color={iconColor}
            />
          )}
          {/*  */}

          <input
            name={name}
            disabled={disable ?? false}
            ref={inpurRef}
            onChange={onChange}
            onClick={onClick}
            type="file"
            style={{ display: "none" }}
            accept={accept}
          />
        </label>
        <div>
          <div className="text_muted_color" style={{ fontSize: 12 }}>
            {fileName ?? "ارفق ملف"}
          </div>
          {message ? (
            <div
              className="text_color"
              onClick={() => {
                inpurRef.current.click();
              }}
              style={{ fontSize: 10, cursor: "pointer" }}
            >
              {message}
            </div>
          ) : null}
        </div>
      </div>
      {uploaded ? (
        <div
          className="text-center text_color mt-1"
          onClick={() => {
            inpurRef.current.click();
          }}
          style={{ fontSize: 10, cursor: "pointer" }}
        >
          {uploadedMessage}
        </div>
      ) : null}
      {error ? (
        <div className="text-center text-danger mt-1">{error}</div>
      ) : null}
    </div>
  );
};

export default FileInput;
